module.exports = __webpack_public_path__ + "img/dog-with-trees-group.aa5e101.svg";